{
  "de": {
    "sublines": {
      "impressum": {
        "general": "General Information (according to § 5 TMG)",
        "disclaimer": "Haftungsausschluss",
        "copyright": "Urheberrecht",
        "thirdpartycontent": "Credits",
        "sponsors": "Sponsoren",
        "liabilityInternal": "Limitation of liability for internal content",
        "liabilityExternal": "Limitation of liability for external links"
      }
    }
  }
}
